// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jt-1";
export var messageSideRight = "_jt-2";
export var orderLookupBubbleContainer = "_jt-0";
export var submitButton = "_jt-3";